/**
 * @enum PHOTO_FINDER_SUBSCRIPTION_BILLING_PERIOD
 * @type {{YEARLY: string, MONTHLY: string}}
 */
export const PHOTO_FINDER_SUBSCRIPTION_BILLING_PERIOD = {
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
};

/**
 * PhotoFinderSubscription features.
 *
 * @type {string[]}
 */
export const PHOTO_FINDER_SUBSCRIPTION_FEATURES = [
  'Photo delivery to attendees via text & app alerts',
  'Automated branding of photos',
  'Dashboard with photo sorting and analytics',
];
